import { axiosInstance } from './api';

const REGISTER = 'auth-service/selfProvision';
const LOCATION = 'geography-service/locations';

export default class RequestApis {
    static register(credentials) {
        const payload = {
            tn: credentials.phoneNumber,
            accessCode: credentials.accessCode
        };
        return axiosInstance.post(REGISTER, payload);
    }
    
    static getLocation(credentials, token) {
        return axiosInstance.get(`${LOCATION}/tn/${credentials.phoneNumber}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        });

    }
    
    static editLocation(credentials, token) {
        const payload = {
            fullAddress: credentials.address,
            info: credentials.location,
            id: credentials.id,
            name: credentials.name
        };

        return axiosInstance.put(`${LOCATION}`, payload, {
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        });

    }
}
